<template>
  <Html :lang="locale">
    <div>
      <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#e8e3dd 0%,#7b7670 100%)" />
      <contact-bar :data="navigation" />
      <NuxtLayout>
        <slot />
      </NuxtLayout>
    </div>
  </Html>
</template>

<script setup>
import {
  useI18n,
  useHead,
  useGql,
  useState,
} from '#imports';

// Favicons
import appleTouchIcon from '@/assets/img/favicon/apple-touch-icon.png';
import favicon32 from '@/assets/img/favicon/favicon-32x32.png';
import favicon16 from '@/assets/img/favicon/favicon-16x16.png';

// Data
const { locale } = useI18n({ useScope: 'global' });
const navigation = useState('navigation', () => null);

if (!navigation.value) {
  navigation.value = await useGql()('navigation', { site: locale.value });
}

// Meta
useHead({
  meta: [
    { name: 'google-site-verification', content: 'QQADZMC0IHmgeDygDGyR2kKH0yjhDu77HxJO_Pqz2QI' },
    { name: 'google-site-verification', content: 'LHOSpO2RLi0BdY2EVI3PwtOG44cbCXss-l6oU9flrOs' },
    { name: 'viewport', content: 'viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no' },
  ],
  link: [
    {
      href: appleTouchIcon, sizes: '180x180', rel: 'apple-touch-icon',
    },
    {
      href: favicon32, sizes: '32x32', rel: 'icon', type: 'image/png',
    },
    {
      href: favicon16, sizes: '16x16', rel: 'icon', type: 'image/png',
    },
  ],
  script: [
    {
      key: 'mailblue-vgo',
      tagPosition: 'bodyClose',
      innerHTML: '(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");vgo("setAccount","69761052");vgo("setTrackByDefault",true);vgo("process");',
    },
  ],
});
</script>
